import { render, staticRenderFns } from "./DoctorStatsAppointment.vue?vue&type=template&id=3cc09b15"
import script from "./DoctorStatsAppointment.vue?vue&type=script&lang=js"
export * from "./DoctorStatsAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports